import { SupportRequestDto } from "@/types/support";
import { BaseService } from "./base.service";

export class SupportService extends BaseService {
  constructor() {
    super("/support");
  }

  // Create a new support request
  async createSupportRequest(data: SupportRequestDto): Promise<boolean> {
    return await this.post<boolean>("", data);
  }
}

export const supportService = new SupportService();
